"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMsgSubmitProposal = exports.MSG_SUBMIT_TYPES = void 0;
exports.MSG_SUBMIT_TYPES = {
    MsgValue: [
        { name: 'content', type: 'any' },
        { name: 'proposer', type: 'string' },
        { name: 'initial_deposit', type: 'TypeDeposit[]' },
    ],
    TypeDeposit: [
        { name: 'denom', type: 'string' },
        { name: 'amount', type: 'string' },
    ],
};
function createMsgSubmitProposal(content, initialDepositDenom, initialDepositAmount, proposer) {
    return {
        type: 'cosmos-sdk/MsgSubmitProposal',
        value: {
            content,
            initial_deposit: [
                {
                    amount: initialDepositAmount,
                    denom: initialDepositDenom,
                },
            ],
            proposer,
        },
    };
}
exports.createMsgSubmitProposal = createMsgSubmitProposal;
//# sourceMappingURL=msgSubmitProposal.js.map